// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@sc/XDL/types";
import { css } from "styled-components";

export default {
    unorderedListProps: {
        css: css`
            padding: 0 0 0 20px;
            ul {
                margin: 24px 0;
            }
        `,
    },
    orderedListProps: {
        css: css`
            padding: 0 0 0 20px;
            ol {
                margin: 24px 0;
                list-style-type: lower-alpha;
            }
        `,
    },
    listItemProps: {
        css: css`
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0;
            line-height: 26px;
            margin-bottom: 16px;
        `,
    },
} as xBaseTheme["lists"];
